// extracted by mini-css-extract-plugin
export var csatScore = "_jx-5";
export var header = "_jx-1";
export var panelWrapper = "_jx-2";
export var postPreview = "_jx-3";
export var rightContent = "_jx-0";
export var wrappingText = "_jx-4";